import Rhea from "./Godess of time.jpg";
import SkyInKurume from "./sky in kurume.jpg";
import Underwater from "./underwater.jpg";
import Teahouse from "./yaoyue tea house.jpg";

export const digitalDrawings = [
  {
    key: "sky-in-kurume",
    src: SkyInKurume,
    title: "Sky in Kurume",
    description: "light study · Krita",
  },
  {
    key: "rhea",
    src: Rhea,
    title: "Rhea - Godess of time",
    description: "posture study · Krita",
  },
  {
    key: "underwater",
    src: Underwater,
    title: "Underwater",
    description: "light study · Procreate",
  },
  {
    key: "teahouse",
    src: Teahouse,
    title: "Yaoyue Tea House",
    description: "light study · Procreate",
  },
];
